import React, { useState } from "react";
import {
  Box,
  InputLabel,
  Paper,
  Rating,
  Stack,
  Typography,
} from "convertupleads-theme";
import PreviewAndEditor from "../../../common/PreviewAndEditor";

const BasicRating = () => {
  const [value, setValue] = useState(2);

  return (
    <Stack spacing={2} p={3}>
      <Box>
        <Typography variant={"h6"} color={"text.primary"}>
          Basic Rating
        </Typography>
      </Box>
      <Paper
        elevation={0}
        sx={{
          width: "80%",
          alignSelf: "center",
        }}
      >
        <Box mb={3}>
          <PreviewAndEditor language={"js"} value={`
            <InputLabel shrink>Controlled</InputLabel>
            <Rating
              name="simple-controlled"
              value={value}
              onChange={(event, newValue) => {
                setValue(newValue);
              }}
            />

            <InputLabel shrink>Read only</InputLabel>
            <Rating name="read-only" value={value} readOnly />

            <InputLabel shrink>Disabled</InputLabel>
            <Rating name="disabled" value={value} disabled />

            <InputLabel shrink>No rating given</InputLabel>
            <Rating name="no-value" value={null} />
          `}>
            <Box
              sx={{
                "& > .MuiInputLabel-root": { mt: 2 },
              }}
            >
              <InputLabel shrink>Controlled</InputLabel>
              <Rating
                name="simple-controlled"
                value={value}
                onChange={(event, newValue) => {
                  setValue(newValue);
                }}
              />

              <InputLabel shrink>Read only</InputLabel>
              <Rating name="read-only" value={value} readOnly />

              <InputLabel shrink>Disabled</InputLabel>
              <Rating name="disabled" value={value} disabled />

              <InputLabel shrink>No rating given</InputLabel>
              <Rating name="no-value" value={null} />
            </Box>
          </PreviewAndEditor>
        </Box>
      </Paper>
    </Stack>
  );
};

export default BasicRating;
